import React from 'react';

const  IconRisk= () => {

    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M14.6973 5.28711C15.2731 4.27939 16.7269 4.27939 17.3027 5.28711L29.8564 27.2559C30.4276 28.2558 29.7053 29.4999 28.5537 29.5H3.44629C2.29469 29.4999 1.5724 28.2558 2.14355 27.2559L14.6973 5.28711Z" stroke="currentColor"/>
            <path d="M16 10V22" stroke="currentColor" strokeLinecap="round"/>
            <circle cx="16" cy="25.5" r="1" fill="currentColor"/>
        </svg>
    )

}

export default IconRisk;
